import React from "react";

/* Stacked brand mark — uses display font + accent square. */
export default function BrandMark({ size = "md", subtle = false }) {
  const sizes = { sm: "text-base", md: "text-lg", lg: "text-2xl" };
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-mark">
      <div
        className={`w-7 h-7 rounded-md bg-brand flex items-center justify-center shadow-glow ${subtle ? "opacity-90" : ""}`}
      >
        <span className="font-display font-bold text-white text-sm leading-none">S</span>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display font-semibold tracking-tight text-ink-primary ${sizes[size]}`}>
          StudioOps
        </span>
        <span className="text-[10px] uppercase tracking-[0.18em] text-ink-secondary mt-0.5">Food</span>
      </div>
    </div>
  );
}
